<template>
  <div class="auditionManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-auditionManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3">
              <span class="c-normal">{{
                $t("Invitationauditionmanage.aa")
              }}</span>
            </div>
          </div>
          <div class="auditionManage-container">
            <div class="content content-special">
              <div class="content-nav--head text-1 Tab-nav-head">
                <div class="c-n--head_lf">
                  <ul class="filter-condition">
                    <li
                      v-for="(item, index) in filtersOption"
                      :key="index"
                      :class="{ 'link-active': index == current }"
                      @click="addClass(index)"
                    >
                      {{ item }}
                    </li>
                  </ul>
                </div>
                <div class="c-n--head_rt">
                  <el-button type="primary" @click="daochu">
                    {{ $t("Common.btn_export") }}
                  </el-button>
                  <!-- *************暂时隐藏***************** -->
                  <!-- <el-button type="primary">导出</el-button> -->
                  <!-- <el-button type="success" @click="showSliderBox = true">新增试听学员</el-button> -->
                </div>
              </div>
              <div class="flex-wrap pl20 pr20">
                <div class="flex-al mb10 mr10">
                  <span class="fs14 color-666">{{
                    $t("Invitationauditionmanage.ad")
                  }}</span>
                  <div class="time-box">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Invitationauditionmanage.ae')"
                      v-model="selectForm.startTime"
                      value-format="yyyy-MM-dd"
                      style="width: 160px"
                      @change="handleSelect()"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{
                      $t("Invitationauditionmanage.af")
                    }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Invitationauditionmanage.ag')"
                      v-model="selectForm.endTime"
                      value-format="yyyy-MM-dd"
                      style="width: 160px"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <!-- <span class="mr10 fs14 color-666">{{$t("Invitationauditionmanage.ab")}}</span> -->
                  <div class="select-box flex-al">
                    <el-select
                      filterable
                      v-model="selectForm.auditionClass"
                      style="width: 145px"
                      clearable
                      :placeholder="
                        $t(
                          'views.Invitationauditionmanage.auditionManage.56gx8eckuxc0'
                        )
                      "
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in SchoolClassOption"
                        :key="item.class_id"
                        :label="item.class_cnname"
                        :value="item.class_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <!-- <span class="mr10 fs14 color-666">{{$t("Invitationauditionmanage.ah")}}</span> -->
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.chiefPerson"
                      style="width: 145px"
                      clearable
                      :placeholder="
                        $t(
                          'views.Invitationauditionmanage.auditionManage.56gx8eckw140'
                        )
                      "
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in chiefPerson"
                        :key="item.marketer_id"
                        :label="item.marketer_name"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.coursetype_id"
                      @change="handleSelect"
                      :placeholder="
                        $t(
                          'views.Invitationauditionmanage.auditionManage.5zlnxhj6n080'
                        )
                      "
                      style="width: 160px"
                    >
                      <el-option
                        v-for="item in selectForm.courseTypeList"
                        :key="`${item.coursetype_cnname}${item.coursetype_id}`"
                        :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                        :value="item.coursetype_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <!-- <span class="mr10 fs14 color-666">{{$t("Invitationauditionmanage.aj")}}</span> -->
                  <div class="select-box">
                    <el-select
                      filterable
                      v-model="selectForm.audition_genre"
                      style="width: 145px"
                      clearable
                      :placeholder="$t('Invitationauditionmanage.ak')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="(item, index) in auditionTypesList"
                        :key="index"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb10 mr10">
                  <div class="select-box">
                    <el-select
                      filterable
                      clearable
                      v-model="selectForm.crm_stu_type"
                      style="width: 160px"
                      :placeholder="
                        $t(
                          'views.Invitationauditionmanage.auditionManage.56gx8eckw9g0'
                        )
                      "
                      @change="handleSelect()"
                    >
                      <el-option
                        :label="
                          $t(
                            'views.Invitationauditionmanage.auditionManage.56gx8eckwg80'
                          )
                        "
                        value="1"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Invitationauditionmanage.auditionManage.56gx8eckwok0'
                          )
                        "
                        value="2"
                      ></el-option>
                      <el-option
                        :label="
                          $t(
                            'views.Invitationauditionmanage.auditionManage.5zlnxhj6nrc0'
                          )
                        "
                        value="3"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <template v-if="current === 4">
                  <div class="flex-al mb10 mr10">
                    <div class="select-box">
                      <el-select
                        filterable
                        clearable
                        v-model="selectForm.audition_allisvisit"
                        style="width: 160px"
                        :placeholder="
                          $t(
                            'views.Invitationauditionmanage.auditionManage.5zlnxhj6nwg0'
                          )
                        "
                        @change="handleSelect()"
                      >
                        <el-option
                          :label="
                            $t(
                              'views.Invitationauditionmanage.auditionManage.56gx8eckx8g0'
                            )
                          "
                          value="0"
                        ></el-option>
                        <el-option
                          :label="
                            $t(
                              'views.Invitationauditionmanage.auditionManage.56gx8eckxfc0'
                            )
                          "
                          value="1"
                        ></el-option>
                        <el-option
                          :label="
                            $t(
                              'views.Invitationauditionmanage.auditionManage.56gx8eckxk00'
                            )
                          "
                          value="-1"
                        ></el-option>
                        <el-option
                          :label="
                            $t(
                              'views.Invitationauditionmanage.auditionManage.5zlnxhj6nzo0'
                            )
                          "
                          value="2"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="flex-al mb10 mr10">
                    <div class="select-box">
                      <el-select
                        filterable
                        clearable
                        v-model="selectForm.cg_coursetype_id"
                        @change="handleSelect"
                        :placeholder="
                          $t(
                            'views.Invitationauditionmanage.auditionManage.5zlnxhj6o2k0'
                          )
                        "
                        style="width: 160px"
                      >
                        <el-option
                          v-for="item in selectForm.courseTypeList"
                          :key="`${item.coursetype_cnname}${item.coursetype_id}`"
                          :label="`${item.coursetype_cnname}(${item.coursetype_branch})`"
                          :value="item.coursetype_id"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </template>

                <div class="flex-al Inquire-box mb10">
                  <div class="ipt-box">
                    <el-input
                      style="width: 350px"
                      clearable
                      :placeholder="
                        $t(
                          'views.Invitationauditionmanage.auditionManage.5zlnxhj6o600'
                        )
                      "
                      class="input-cont"
                      @change="handleSelectKeyword()"
                      v-model="selectForm.keyword"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Invitationauditionmanage.ap") }}</el-button
                  >
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <TableList
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :operates="operates"
                  :issetting="true"
                  :tableOperate="tableOperate"
                  @toggleEditableColumn="toggleEditableColumn"
                  @handleColumnChange="handleColumnChange"
                ></TableList>
              </div>

              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 侧边新建栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBox"
      @hideSliderBox="hideSliderBox"
      :sliderWidth="sliderWidth"
    >
      <userCreate
        :showUserSliderBox="showSliderBox"
        :Userlist="Userlistcreate"
        @hideUserSliderBox="hideSliderBox"
      ></userCreate>
    </SliderBox>

    <!-- 已试听 -->
    <el-dialog
      :title="$t('Invitationauditionmanage.bj')"
      :visible.sync="visitedJG"
      class="tan-binding"
      width="520px"
      :before-close="handleClose"
    >
      <div class="create">
        <div class="delTips tc">
          {{ studentName_invited }}{{ $t("Invitationauditionmanage.aq") }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <template
          v-if="
            scopedData &&
              (scopedData.is_forbid != 1 || scopedData.client_tracestatus == 4)
          "
        >
          <template v-if="scopedData.audition_type == 0">
            <el-button
              type="primary"
              :disabled="
                (scopedData.isgmcIndschoolenter == 1 &&
                  scopedData.isgmcschoolenter != 1) ||
                  !isPrincipal
              "
              @click="ClickNoVisited(inviteInfor)"
            >
              {{ $t("Invitationauditionmanage.ar") }}
            </el-button>
            <el-button @click="visitedJG = false">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <el-button
            type="default"
            size="small"
            v-else-if="scopedData.audition_type == 1"
            @click="visitedJG = false"
          >
            {{
              $t("views.Invitationauditionmanage.auditionManage.56gx8eckwwg0")
            }}
          </el-button>
        </template>

        <template v-else>
          <template v-if="scopedData && scopedData.audition_type == 0">
            <el-button type="primary" disabled>{{
              $t("Invitationauditionmanage.ar")
            }}</el-button>
            <el-button @click="visitedJG = false">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <template v-else-if="scopedData && scopedData.audition_type == 1">
            <el-button type="default" size="small" @click="visitedJG = false">{{
              $t("views.Invitationauditionmanage.auditionManage.56gx8eckwwg0")
            }}</el-button>
          </template>
        </template> -->

        <div class="flex-all">
          <div></div>
          <div class="flex-al">
            <div class="flex-al mr10">
              <span class="color-orange fs14 mr10">
                仅名单负责人以及主管可直接跟进
              </span>
              <el-button
                :disabled="!isPrincipal && postbe_crmuserlevel != 1"
                type="primary"
                @click="ClickNoVisited(inviteInfor)"
              >
                继续跟进
              </el-button>
            </div>
            <el-button @click="visitedJG = false"> 关闭 </el-button>
          </div>
        </div>
      </span>
    </el-dialog>

    <!-- 未试听 -->
    <el-dialog
      :title="$t('Invitationauditionmanage.bi')"
      :visible.sync="visitingJG"
      class="tan-binding"
      width="500px"
      :before-close="handleClose"
    >
      <div class="create">
        <div class="info-textarea">
          <el-form ref="form" :model="reasonForm" label-width="90px">
            <el-form-item :label="$t('Invitationauditionmanage.at')">
              <el-select
                filterable
                v-model="reasonForm.select"
                style="width: 300px"
                :placeholder="$t('Invitationauditionmanage.au')"
                @change="handleClickreson()"
              >
                <el-option
                  v-for="(item, index) in reasonOptinon"
                  :key="index"
                  :label="item.reason_note"
                  :value="item.reason_note"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label=" "
              prop="textarea"
              :rules="[
                {
                  required: true,
                  message: '请选择原因',
                },
              ]"
            >
              <el-input
                clearable
                type="textarea"
                style="width: 300px"
                :placeholder="$t('Invitationauditionmanage.av')"
                v-model="reasonForm.textarea"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="ClickNoVisiting(inviteInfor)">继续跟进</el-button> -->
        <!-- <template
          v-if="
            scopedData &&
              (scopedData.is_forbid != 1 || scopedData.client_tracestatus == 4)
          "
        >
          <template v-if="scopedData.audition_type == 0">
            <el-button
              type="primary"
              :disabled="
                (scopedData.isgmcIndschoolenter == 1 &&
                  scopedData.isgmcschoolenter != 1) ||
                !isPrincipal
              "
              @click="ClickNoVisiting(inviteInfor)"
            >
              {{ $t("Invitationauditionmanage.ar") }}
            </el-button>
            <el-button type="primary" @click="ClickNoFloow()">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <template v-else-if="scopedData.audition_type == 1">
            <el-button size="small" type="primary" @click="ClickNoFloow()">{{
              $t("views.Invitationauditionmanage.auditionManage.56gx8eckwwg0")
            }}</el-button>
          </template>
        </template>
        <template v-else>
          <template v-if="scopedData && scopedData.audition_type == 0">
            <el-button type="primary" disabled>{{
              $t("Invitationauditionmanage.ar")
            }}</el-button>
            <el-button @click="ClickNoFloow()">{{
              $t("Invitationauditionmanage.as")
            }}</el-button>
          </template>
          <template v-else-if="scopedData && scopedData.audition_type == 1">
            <el-button size="small" type="primary" @click="ClickNoFloow()">{{
              $t("views.Invitationauditionmanage.auditionManage.56gx8eckwwg0")
            }}</el-button>
          </template>
        </template> -->

        <div class="flex-all">
          <div></div>
          <div class="flex-al">
            <div class="flex-al mr10">
              <span class="color-orange fs14 mr10">
                仅名单负责人以及主管可直接跟进
              </span>
              <el-button
                :disabled="!isPrincipal && postbe_crmuserlevel != 1"
                type="primary"
                @click="ClickNoVisiting(inviteInfor)"
              >
                提交并继续跟进
              </el-button>
            </div>
            <el-button @click="ClickNoFloow"> 提交 </el-button>
          </div>
        </div>
      </span>
    </el-dialog>
    <!-- 侧边栏查看-->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <userSeeing
        :showUserSliderBox="showSliderBoxSee"
        :createJG="createJG"
        :customerId="customerId"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :isRoot="isRoot"
        :isshowfirst="true"
        :isForm="true"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @handleSliderClick="handleSliderClick"
        @Clickedit="Clickedit"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        @updateList="updateList"
      ></userSeeing>
    </SliderBox>
    <!-- 绑定学员 -->
    <el-dialog
      :title="$t('Invitationauditionmanage.aw')"
      :visible.sync="createJG"
      class="tan-binding"
      width="30%"
      :before-close="handleClose"
    >
      <div class="create">
        <el-form
          label-width="120px"
          ref="BindstudentFrom"
          :model="BindstudentFrom"
        >
          <el-form-item
            :label="$t('Invitationauditionmanage.ax')"
            prop="name"
            :rules="[
              {
                required: true,
                message: $t(
                  'views.Invitationauditionmanage.auditionManage.5zlnxhj6o8w0'
                ),
              },
            ]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.name"
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              style="width: 200px"
              :placeholder="$t('Invitationauditionmanage.ay')"
            >
              <el-option
                v-for="item in FriendName"
                :key="item.client_id"
                :value="item.client_id"
                :label="item.client_cnname"
              >
                {{ item.client_cnname }}
                <i slot="suffix" class="el-input__icon el-icon-date"></i>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('Invitationauditionmanage.az')"
            prop="relation"
            :rules="[
              {
                required: true,
                message: $t(
                  'views.Invitationauditionmanage.auditionManage.5zlnxhj6obo0'
                ),
              },
            ]"
          >
            <el-select
              filterable
              v-model="BindstudentFrom.relation"
              style="width: 200px"
              :placeholder="$t('Invitationauditionmanage.ba')"
            >
              <el-option
                v-for="item in FriendRelation"
                :key="item.friendrelation_id"
                :value="item.friendrelation_name"
                :label="item.friendrelation_name"
                >{{ item.friendrelation_name }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onBindSubmit()">{{
          $t("Invitationauditionmanage.bb")
        }}</el-button>
        <!-- <el-button @click="createJG = false">取 消</el-button> -->
      </span>
    </el-dialog>
    <!-- 跟班试听 中间-->
    <auditClass
      :leaningVisible="leaningVisible"
      :auditionGenre="auditionGenre"
      :Auditiontime="Auditiontime"
      @handClickcompare="handClickcompare"
      @handClickcancel="handClickcancel"
      @handleClose="handleCloseLean"
      :leaningFilterData="leaningFilterData"
    ></auditClass>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Invitationauditionmanage.bc')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="[
          $t('Invitationauditionmanage.bd'),
          $t('Invitationauditionmanage.be'),
        ]"
        v-model="oprateColumn"
        @change="Changeoprate()"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Invitationauditionmanage.bb")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 流失学员查看 -->
    <slider-box
      :showSliderBox="showLSSliderBoxSee"
      @hideSliderBox="hideSliderSeeBox"
      :sliderWidth="sliderWidth"
    >
      <schoolSeeing
        :showUserSliderBox="showLSSliderBoxSee"
        :customerId="customerId"
        :sId="sId"
        :sType="sType"
        :ClassMessage="ClassMessage"
        :seeSliderTitle="seeSliderTitle"
        :isTrack="isTrack"
        :activeName="activeName"
        :isRoot="isRoot"
        @hideUserSliderBox="hideSliderSeeBox"
        @studentBinding="studentBinding"
        @Clickedit="Clickedit"
        @handleSliderClick="handleSliderClick"
        @leaning="leaning"
        @onFllowSubmit="onFllowSubmit"
        @ClickFloow="ClickFloow"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        :campusrosterStuData="campusrosterStuData"
        studentType="1"
      ></schoolSeeing>
    </slider-box>

    <!-- 改约-->
    <SliderBox
      :showSliderBox="changeAppointVisible"
      sliderWidth="700px"
      @hideSliderBox="hideSliderSeeBox"
    >
      <change-appoint
        @hideUserSliderBox="hideSliderSeeBox"
        :clientId="clientId"
        :inviteId="inviteId"
        :auditionId="auditionId"
        pageFrom="audition"
        @leaning="leaning"
        @ClickAudition="ClickAudition"
        @ClickAuditiontime="ClickAuditiontime"
        :ClassMessage="ClassMessage"
        @updatelist="getAuditionData"
      ></change-appoint>
    </SliderBox>
  </div>
</template>
<script>
import PageNav from "@/components/Nav/nav.vue";
// import echarts from "echarts";
import schoolSeeing from "@/components/User/schoolSeeing.vue";
import SliderBox from "@/components/SliderBox";
import TableList from "@/components/Table/table.vue";
import userCreate from "@/components/User/create.vue";
import userSeeing from "@/components/User/seeing.vue";
import auditClass from "@/components/Class/Class.vue";
import storeInvitationauditionmanage from "./Invitationauditionmanage.js";
import ChangeAppoint from "@/components/User/change-appoint.vue";
export default {
  name: "Auditionmanage-auditionManage",
  data() {
    return {
      leaningFilterData: null,
      changeAppointVisible: false,

      isPrincipal: false,
      showLSSliderBoxSee: false,
      sId: "",
      sType: "",
      campusrosterStuData: null,

      auditionTypesList: [],
      scopedData: null,
      openMenu: ["4"],
      showSliderBox: false,
      showSliderBoxSee: false,
      leaningVisible: false,
      loading: false,
      createJG: false,
      fullscreenLoading: true, //全屏loading
      settingVisible: false,
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      data: [],
      seeSliderTitle: this.$t("Invitationauditionmanage.bf"),
      clientLevelNum: "", //存储意向星级数目
      ClassMessage: {}, //选择的试听班级
      inviteInfor: [],
      customerId: "", // 客户id
      isTrack: false, //是否点击跟进
      isRoot: false,
      //绑定学员
      BindstudentFrom: {
        name: "",
        relation: "",
      },
      chiefPerson: [], //主负责人
      fu_chiefPerson: [], //副负责人
      FriendName: [], //用户绑定人员名称
      FriendRelation: [], //用户绑定关系
      followFormid: "",
      layoutVisible: false, //分配
      auditionGenre: "", //试听类型
      Auditiontime: "", //试听时间
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      dialogVisible: false,
      // 已试听学生姓名
      studentName_invited: "",
      //筛选条件
      selectForm: {
        auditionClass: "",
        startTime: "",
        endTime: "",
        chiefPerson: "",
        audition_genre: "",
        keyword: "",
        crm_stu_type: "",
        audition_allisvisit: "",
        cg_coursetype_id: "",
        courseTypeList: [],
        coursetype_id: "",
      },
      //未试听原因
      reasonForm: {
        select: "",
        textarea: "",
      },
      reasonOptinon: [],
      current: 0,
      visitedJG: false,
      visitingJG: false,
      levelNum: 5, //侧边栏个数
      sliderWidth: "700px", //侧边栏宽度
      activeName: "first",
      checkList: [],
      // 侧边栏 资料建档
      Userlistcreate: {
        containClass: "slider-goalManage",
        sliderTitle: this.$t("Invitationauditionmanage.bg"),
      },
      filtersOption: [
        this.$t("views.Invitationauditionmanage.auditionManage.56gx8eckx8g0"),
        this.$t("views.Invitationauditionmanage.auditionManage.56gx8eckxfc0"),
        this.$t("views.Invitationauditionmanage.auditionManage.56gx8eckxk00"),
        this.$t("views.Invitationauditionmanage.auditionManage.5zlnxhj6nzo0"),
        this.$t("views.Invitationauditionmanage.auditionManage.5zlnxhj6ofc0"),
      ],
      SchoolClassOption: [],
      IsvisterReasonid: "",
      // 表格数据
      columnWidth: ["200", "200", "150", "150", "250", "250", "250", "250"], //表格宽度
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
        // specialColumns:true//特殊列
      },
      columns: [],
      allColumns: [],
      operates: {
        width: 200,
        label: this.$t("Invitationauditionmanage.bk"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("Invitationauditionmanage.bja"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.scopedData = row;
              this.handleOneClick(row);
            },
          },
          {
            id: "2",
            label: this.$t("Invitationauditionmanage.bia"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.scopedData = row;
              this.isMarketerClientPrincipal();
              this.handleTwoClick(row);
            },
          },

          {
            id: "3",
            label: this.$t(
              "views.Invitationauditionmanage.auditionManage.5zlnxhj6oi40"
            ),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            changeAppoint: true,
            method: (index, row) => {
              this.scopedData = row;
              this.changeAppointVisible = true;
            },
          },
        ],
      }, // 列操作按钮
      tableOperate: {
        label: "11",
        operate: true,
        align: "center",
        fixed: "right",
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {
    PageNav,
    SliderBox,
    userCreate,
    userSeeing,
    auditClass,
    TableList,
    schoolSeeing,
    ChangeAppoint,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";

    let current = this.$route.query.current;
    if (current) {
      this.selectForm.startTime = this.$Common.getAppointedDate(2, 0).startDate;
      this.selectForm.endTime = this.$Common.getAppointedDate(2, 0).endDate;
      this.current = current;
    }

    this.getAuditionData();
    this.getMarketer(); // 获取招生的负责人
    this.getAuditionTypesApi();
    this.getCourseType();
    // this.optionscaozuo.tableHeight=this.$Common.getTableHeight(400);//设置表格高度
  },
  methods: {
    isMarketerClientPrincipal() {
      storeInvitationauditionmanage
        .isMarketerClientPrincipal({
          audition_id: this.scopedData.audition_id,
        })
        .then((res) => {
          const { data } = res.data;
          this.isPrincipal = data.is_principal;
        });
    },
    getCourseType() {
      storeInvitationauditionmanage
        .getCourseType({
          ishaveopenclass: 1,
          marketer_id: this.$store.state.MARKETER_ID,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.selectForm.courseTypeList = [...data.list];
          } else {
            this.selectForm.courseTypeList = [];
          }
        });
    },
    updateList() {
      this.getAuditionData();
    },
    getAuditionTypesApi() {
      storeInvitationauditionmanage.getAuditionTypesApi({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.auditionTypesList = data.list;
        } else {
          this.auditionTypesList = [];
        }
      });
    },
    // 试听管理表格数据
    getAuditionData() {
      storeInvitationauditionmanage
        .getAudition({
          is_count: "1", //是否需要总数，可以不传
          p: this.currentPage,
          num: this.pagesize,
          audition_isvisit:
            this.current == 0
              ? "0"
              : this.current == 1
              ? "1"
              : this.current == 2
              ? "-1"
              : this.current == 3
              ? "2"
              : "",
          // 非必须传
          coursetype_id: this.selectForm.coursetype_id,
          class_id: this.selectForm.auditionClass,
          audition_starttime: this.selectForm.startTime,
          audition_endtime: this.selectForm.endTime,
          main_marketer_id: this.selectForm.chiefPerson,
          audition_genre: this.selectForm.audition_genre,
          keyword: this.selectForm.keyword,
          crm_stu_type: this.selectForm.crm_stu_type,
          audition_allisvisit: this.selectForm.audition_allisvisit,
          cg_coursetype_id: this.selectForm.cg_coursetype_id,
        })
        .then((res) => {
          const { code, msg, data: body } = res.data;
          const allnum = body.allnum;
          const data = body;
          this.SchoolClassOption = [...data.classList];
          this.tableData = data.list;
          this.dataNumber = parseInt(allnum);

          var Columns = data.field;
          this.allColumns = data.field;
          this.$Tool.setStorage("allauditColumns", this.allColumns);
          this.showColumn = JSON.parse(
            localStorage.getItem("showauditColumns")
          );
          var fieldColumns = data.field;
          if (JSON.parse(localStorage.getItem("showauditColumns"))) {
            Columns = this.showColumn;
            fieldColumns = this.showColumn;
          }
          this.columns = this.$Common.handleTable(
            Columns,
            this.columnWidth,
            true,
            0
          );
          this.columns.forEach((v) => {
            if (v.prop == "client_tag") {
              this.$set(v, "istag", true);
              this.$set(v, "width", "220px");
            }
          });
          this.optionscaozuo.loading = false;
          var arr = [];
          var arr2 = [];
          fieldColumns.forEach((item, index) => {
            arr.push({
              key: index,
              label: item.fieldstring,
              disabled: item.custom === "0",
            });
            if (item.show == "0") {
              arr2.push(index);
            }
          });
          this.data = arr;
          this.oprateColumn = arr2;
          if (code !== 200) {
            this.optionscaozuo.errortip = msg;
          }
          // (() => {})(this.columns)
        });
    },
    // 试听管理->设置试听或未试听 status:1为已试听,0为未试听
    postIsauditionData(status, id) {
      storeInvitationauditionmanage
        .postIsaudition({
          marketer_id: this.marketer_id,
          token: this.token,
          audition_id: id,
          audition_isvisit: status,
          audition_type: this.scopedData.audition_type,
          audition_novisitreason: this.reasonForm.textarea,
        })
        .then((res) => {
          // (() => {})(res.data);
          const { code, data, msg } = res.data;
          if (code === 200) {
            this.isPrincipal = data.is_principal;
            if (status == "1") {
              this.visitedJG = true;
            } else {
              this.visitingJG = false;
            }
            this.getAuditionData();
          } else {
            this.$message.error(msg);
          }
        });
    },
    // 获取招生的负责人
    getMarketer() {
      storeInvitationauditionmanage
        .getMarketer({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.chiefPerson = res.data.data.list;
          // this.chiefPerson.unshift({
          //   marketer_id: "",
          //   marketer_name: this.$t("Invitationauditionmanage.ac")
          // });
        });
    },
    // 获取未试听原因模板
    getIsvisterReasonData() {
      storeInvitationauditionmanage
        .getIsvisterReason({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
        })
        .then((res) => {
          (() => {})(res.data);
          this.reasonOptinon = res.data.data.list;
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getAuditionData();
      // if (this.current == 0) {
      //   this.getAuditionData(this.pagenum, "0");
      // } else if (this.current == 1) {
      //   this.getAuditionData(this.pagenum, "1");
      // } else if (this.current == 2) {
      //   this.getAuditionData(this.pagenum, "-1");
      // } else if (this.current == 3) {
      //   this.getAuditionData(this.pagenum, "");
      // }
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getAuditionData();
      // if (this.current == 0) {
      //   this.getAuditionData(this.pagenum, "0");
      // } else if (this.current == 1) {
      //   this.getAuditionData(this.pagenum, "1");
      // } else if (this.current == 2) {
      //   this.getAuditionData(this.pagenum, "-1");
      // } else if (this.current == 3) {
      //   this.getAuditionData(this.pagenum, "");
      // }
    },
    // 原因选择
    handleClickreson() {
      (() => {})(this.reasonForm.select);
      this.reasonForm.textarea = this.reasonForm.select;
    },
    // 未试听继续跟进
    ClickNoVisiting(v) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postIsauditionData("-1", this.IsvisterReasonid);
          // this.visitingJG=false;
          this.isRoot = true;
          this.isTrack = true; //是否点击我要跟进
          this.from_client_id = v.client_id;
          this.followFormid = v.client_id; //跟进
          this.customerId = v.client_id; //存储客户ID
          this.showSliderBoxSee = true;
        } else {
          return;
        }
      });
    },
    // 未试听暂不跟进
    ClickNoFloow() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postIsauditionData("-1", this.IsvisterReasonid);
          // this.visitingJG = false;
        } else {
          return;
        }
      });
    },
    // 已试听继续跟进
    ClickNoVisited(v) {
      this.visitedJG = false;
      this.isRoot = true;
      this.isTrack = true; //是否点击我要跟进
      this.from_client_id = v.client_id;
      this.followFormid = v.client_id; //跟进
      this.customerId = v.client_id; //存储客户ID
      this.showSliderBoxSee = true;
    },
    // 获取单个客户的绑定关系
    getFriendRelationData(id) {
      storeInvitationauditionmanage
        .getFriendRelation({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_id: id,
        })
        .then((res) => {
          (() => {})(res.data.data.list);
          this.FriendRelation = res.data.data.list;
        });
    },
    // 绑定学员->获取人员名称
    getClientNameData(keyword) {
      storeInvitationauditionmanage
        .getClientName({
          marketer_id: this.marketer_id,
          token: this.token,
          company_id: this.company_id,
          school_id: this.school_id,
          client_cnname: keyword,
        })
        .then((res) => {
          // (() => {})(res.data.data.list);
          this.FriendName = res.data.data.list;
          this.loading = false;
        });
    },
    // 远程搜索绑定学员的名称
    remoteMethod(query) {
      (() => {})(query);
      if (query !== "") {
        this.loading = true;
        this.getClientNameData(query);
      } else {
        this.FriendName = [];
      }
    },
    //绑定学员提交
    onBindSubmit() {
      // (() => {})(this.BindstudentFrom);
      storeInvitationauditionmanage
        .bindingClient({
          token: this.token,
          marketer_id: this.marketer_id,
          from_client_id: this.from_client_id,
          to_client_id: this.BindstudentFrom.name,
          binding_friend_relation: this.BindstudentFrom.relation,
        })
        .then((res) => {
          // (() => {})(res.data);
          if (res.data.code === 200) {
            // this.$Tool.successTip(res.data.msg);
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getAuditionData();
            this.createJG = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    // 绑定学员显示
    studentBinding() {
      this.BindstudentFrom = {
        name: "",
        relation: "",
      }; //数据初始化
      this.getFriendRelationData();
      this.createJG = true;
    },
    //查看点击编辑
    Clickedit() {
      this.showSliderBoxSee = false;
      this.showSliderBox = true;
    },
    //点击查看
    handleColumnChange(k, v) {
      this.isRoot = false;
      this.activeName = "first";
      this.iscanEdit = true;
      this.from_client_id = v.client_id;
      this.customerId = v.client_id; //存储客户ID
      this.sId = v.client_id;
      // this.getclientOneData(v.client_id);
      // this.getclientOneTrackData(v.client_id);
      // this.getFriendRelationData(v.client_id);
      // this.getclientOneInviteData(v.client_id); //柜询记录
      // this.getclientOneAuditionData(v.client_id); //试听记录
      // this.getBindingClientData(v.client_id);//绑定学员信息

      // this.showSliderBoxSee = true;
      if (v.audition_type == 0) {
        this.isTrack = false;
        this.showSliderBoxSee = true;
      } else if (v.audition_type == 1) {
        this.isTrack = false;
        this.getCrmStudentOneApi(v.client_id);
        this.showLSSliderBoxSee = true;
      }
    },
    getCrmStudentOneApi(sid) {
      storeInvitationauditionmanage
        .getCrmStudentOneApi({
          student_id: sid,
          marketer_id: this.marketer_id,
        })
        .then((res) => {
          const { data } = res.data;
          this.campusrosterStuData = data;
          this.showSliderBoxSee = true;
        });
    },
    //跟进提交
    onFllowSubmit(v) {
      // v.track_intention_level = this.clientLevelNum.length;
      v.token = this.token;
      v.marketer_id = this.marketer_id;
      v.school_id = this.school_id;
      v.company_id = this.company_id;
      if (this.followFormid != "") {
        v.client_id = this.followFormid;
      }
      // v.client_id=this.followFormid;
      (() => {})(v);
      storeInvitationauditionmanage.settingtrackClient(v).then((res) => {
        (() => {})(res.data);
        if (res.data.code === 200) {
          // this.$Tool.successTip(res.data.msg);
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getAuditionData();
          this.showSliderBoxSee = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 绑定学员点击跟进
    ClickFloow(v) {
      this.customerId = v.client_id;
    },
    hideSliderSeeBox() {
      this.showSliderBoxSee = false;
      this.showLSSliderBoxSee = false;
      this.changeAppointVisible = false;
    },
    //跟班试听
    leaning(v) {
      (() => {})(v, "v");
      if (v) {
        this.leaningFilterData = v;
      } else {
        this.leaningFilterData = null;
      }
      this.leaningVisible = true;
    },
    // 试听类型
    ClickAudition(v) {
      this.auditionGenre = v;
    },
    // 试听时间
    ClickAuditiontime(v) {
      (() => {})(v, 121213);
      this.Auditiontime = v;
    },
    // 编辑列
    Changeoprate() {
      (() => {})(
        this.$t("views.Invitationauditionmanage.auditionManage.56gx8eckxo00")
      );
    },
    // 自定义编辑列
    handClickOprate() {
      let allnum = JSON.parse(localStorage.getItem("allauditColumns"));
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item) => {
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      this.$Tool.setStorage("showauditColumns", this.showColumns);
      this.settingVisible = false;
      this.getAuditionData();
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    handClickcompare(v) {
      this.ClassMessage = v;
      this.leaningVisible = false;
    },
    handClickcancel() {
      this.leaningVisible = false;
    },
    handleCloseLean() {
      this.$confirm(this.$t("Invitationauditionmanage.bn"))
        .then(() => {
          this.leaningVisible = false;
        })
        .catch((_) => {
          (() => {})(_);
        });
    },

    hideSliderBox() {
      this.showSliderBox = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    onSubmit() {
      (() => {})(this.form);
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(v) {
      (() => {})(v), 11111111;
      if (v == "first") {
        this.iscanEdit = true;
        //  this.getclientOneData(this.customerId);
      } else {
        if (v == "fourth") {
          this.isRoot = true;
        } else {
          this.iscanEdit = false;
          // this.isRoot=false;
        }
      }
    },
    handleOneClick(v1) {
      this.postIsauditionData("1", v1.audition_id);
      this.inviteInfor = v1;
      this.studentName_invited = v1.client_cnname;
      (() => {})(v1);
    },
    handleTwoClick(v1) {
      this.reasonForm = {
        select: "",
        textarea: "",
      }; //数据情空
      this.visitingJG = true;
      this.inviteInfor = v1;
      this.visitingJG = true;
      this.getIsvisterReasonData();
      this.IsvisterReasonid = v1.audition_id;
    },
    handleClick(v) {
      this.showSliderBox = true;
      (() => {})(v);
    },
    handleClose(done) {
      this.$confirm(this.$t("Invitationauditionmanage.bn"))
        .then((_) => {

          done();
        })
        .catch(() => {

        });
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getAuditionData()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getAuditionData()
    },
    // tab切换
    addClass(index) {
      this.current = index;
      this.selectForm.auditionClass = "";
      this.selectForm.startTime = "";
      this.selectForm.endTime = "";
      this.selectForm.chiefPerson = "";
      this.selectForm.audition_genre = "";
      this.selectForm.keyword = "";
      this.selectForm.crm_stu_type = "";
      this.selectForm.audition_allisvisit = "";
      this.selectForm.cg_coursetype_id = "";
      this.selectForm.coursetype_id = "";
      this.currentPage = 1;
      this.getAuditionData()
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      let type = "";
      if (this.current == 0) {
        type = "0";
      } else if (this.current == 1) {
        type = "1";
      } else if (this.current == 2) {
        type = "-1";
      } else if (this.current == 3) {
        type = "2";
      } else if (this.current == 4) {
        type = "";
      }
      params_str = `&audition_isvisit=${type}&audition_starttime=${this.selectForm.startTime}&audition_endtime=${this.selectForm.endTime}&keyword=${this.selectForm.keyword}&audition_genre=${this.selectForm.audition_genre}&main_marketer_id=${this.selectForm.chiefPerson}&crm_stu_type=${this.selectForm.crm_stu_type}&audition_allisvisit=${this.selectForm.audition_allisvisit}&cg_coursetype_id=${this.selectForm.cg_coursetype_id}`;
      let url = storeInvitationauditionmanage.getAudition1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  computed: {
    clientId() {
      return this.scopedData ? this.scopedData.client_id : "";
    },
    inviteId() {
      return this.scopedData ? this.scopedData.invite_id : "";
    },
    auditionId() {
      return this.scopedData ? this.scopedData.audition_id : "";
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 95
        );
      }
    });
  },
};
</script>
<style lang="less">
@import url("../../assets/less/manage.less");
@import url("Invitationauditionmanage.less");
.auditionManage {
  height: 100vh;
  font-size: 20px;
}
</style>
